var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarouselLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8322 12.1582C22.8854 12.2082 22.9276 12.2676 22.9564 12.333C22.9852 12.3984 23 12.4685 23 12.5394C23 12.6102 22.9852 12.6803 22.9564 12.7457C22.9276 12.8111 22.8854 12.8705 22.8322 12.9205L16.3801 19.0001L22.8322 25.0797C22.9394 25.1808 22.9997 25.3179 22.9997 25.4609C22.9997 25.6039 22.9394 25.741 22.8322 25.8421C22.7249 25.9432 22.5794 26 22.4277 26C22.276 26 22.1305 25.9432 22.0232 25.8421L15.1678 19.3813C15.1146 19.3313 15.0724 19.2719 15.0436 19.2065C15.0148 19.1411 15 19.071 15 19.0001C15 18.9293 15.0148 18.8592 15.0436 18.7938C15.0724 18.7284 15.1146 18.669 15.1678 18.619L22.0232 12.1582C22.0763 12.108 22.1393 12.0683 22.2087 12.0411C22.2782 12.014 22.3526 12 22.4277 12C22.5028 12 22.5772 12.014 22.6467 12.0411C22.7161 12.0683 22.7791 12.108 22.8322 12.1582Z",
    fill: "#02F6AD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 37,
    rx: 18.5,
    stroke: "#02F6AD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselLeft);
export default __webpack_public_path__ + "static/media/carouselLeft.057a3107bca67313139978f10f5da7b4.svg";
export { ForwardRef as ReactComponent };